import React from "react"
export function CheckboxField({ value }: { value: boolean | undefined }): JSX.Element {
  return <input
    type="checkbox"
    className='h-10 py-1 pl-4 border-0 text-base lg:text-lg bg-cents-grey rounded-2xl focus:ring-0 h-5 w-5 ml-4 my-2.5'
    checked={value}
    disabled
  />
}